// Wizard / Buttons
//
// Buttons that appear on the bottom of the wizard

import * as React from 'react';
import Button from 'lj_shared/button/button';
import InlineIcon from '../../../general/inline_icon/inline_icon';
import classnames from 'classnames';
const chevronPath = require('svg/thin-chevron.svg');
const styles = require('./wizard_buttons.module.scss');

interface Props {
  nextUrl?: string;
  previousUrl?: string;
  isSubmitStep?: boolean;
}

export default class WizardButtons extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    if (this.props.isSubmitStep && this.props.previousUrl) {
      return submitButtonsWithPrevious(this.props);
    } else if (this.props.previousUrl) {
      return moveButtons(this.props);
    } else {
      return submitButton(this.props);
    }
  }

  componentDidMount() {
    if (this.props.previousUrl && !this.props.isSubmitStep) {
      const nextButtons = document.querySelectorAll('.sidebar-next-button');
      const formNextButton: HTMLElement = document.querySelector('.next-button');

      for (const button of nextButtons as any) {
        button.addEventListener('click', () => {
          formNextButton.click();
        });
      }
    } else {
      // Function to handle terms validation
      const handleTermsValidation = (ev: Event) => {
        ev.preventDefault();
        const terms: any = document.getElementById('terms');
        const errorAlert = document.querySelector('.terms .ld-alert') as HTMLElement;
        
        if (terms && terms.checked) {
          // Hide error if shown
          if (errorAlert) {
            errorAlert.style.display = 'none';
          }
          // Find and submit the form
          const form = document.querySelector('form[data-step]') as HTMLFormElement;
          if (form) {
            form.submit();
          }
        } else {
          // Show error message
          if (errorAlert) {
            errorAlert.style.display = 'block';
          }
        }
      };

      // Attach to the main submit button
      const mainSubmitButton = document.querySelector('#submit-approval') as HTMLElement;
      if (mainSubmitButton) {
        mainSubmitButton.onclick = handleTermsValidation;
      }

      // Also attach to sidebar submit button when it's on the final step
      // Wait a bit for sidebar to mount
      setTimeout(() => {
        const sidebarButtons = document.querySelectorAll('.sidebar-next-button');
        sidebarButtons.forEach((button) => {
          // Check if this is the final step by looking at button text
          if (button.textContent && button.textContent.includes('Submit for Approval')) {
            (button as HTMLElement).onclick = handleTermsValidation;
          }
        });
      }, 100);
    }
  }
}

function submitButton(props) {
  return (
    <div className={styles.buttons}>
      <Button
        otherId='submit-approval'
        otherClasses='submit-button'
        buttonColor='ripePlum'
        buttonSize='large'
      >
        <span style={{ color: 'white' }}>Submit for Approval</span>
      </Button>
    </div>
  );
}

function submitButtonsWithPrevious(props) {
  return (
    <div className={styles.buttons}>
      <Button
        buttonUrl={props.previousUrl}
        otherClasses={classnames(styles.previousButton, 'previous-button')}
        buttonColor='silverSand'
        buttonType='border'
      >
        <InlineIcon path={chevronPath} alt='previous-step' />
        Previous
      </Button>
      <Button
        otherId='submit-approval'
        otherClasses={classnames(styles.nextButton, 'submit-button')}
        buttonColor='ripePlum'
        isButton={true}
        type='button'
      >
        Submit for Approval
      </Button>
    </div>
  );
}

function moveButtons(props) {
  return (
    <div className={styles.buttons}>
      <Button
        buttonUrl={props.previousUrl}
        otherClasses={classnames(styles.previousButton, 'previous-button')}
        buttonColor='silverSand'
        buttonType='border'
      >
        <InlineIcon path={chevronPath} alt='previous-step' />
        Previous
      </Button>
      <Button
        otherClasses={classnames(styles.nextButton, 'next-button')}
        buttonColor='ripePlum'
        isButton={true}
      >
        Next
        <InlineIcon path={chevronPath} alt='next-step' />
      </Button>
    </div>
  );
}
